import { render, staticRenderFns } from "./HostedLinks2.vue?vue&type=template&id=1bdc0595"
import script from "./HostedLinks2.vue?vue&type=script&lang=js"
export * from "./HostedLinks2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports